import React, { Component } from 'react';

// import { language } from 'settings';
// import { DataHandler, ContentHeader, ContactCard } from 'C4';
// // import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import i18n from 'i18n-react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { HashLink as Link } from 'react-router-hash-link';
// import APIHandler from 'config/APIHandler';
import ContentHeader from 'components/ContentHeader';

export default class ContactView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      
    };
  }

  render() {
    return (
      <div className="contentContainer advisorView">
        <div className="backgroundImage" />
        <ContentHeader
          header="Advisor Community Board"
          subtitle="Engage with other users in the General Area or extend the conversation around a specific topic!"
          line
        />
        <img src="https://front.travpromobile.com/1394/Group%2054.png" alt='advisor-board'/>
      </div>
    );
  }
}
